<div class="p-3">
  <div
    *ngIf="step !== NewsletterWelcomeSystemStepEnum.SELECT_TYPE"
    class="flex gap-3 justify-content-between">
    <button
      pButton
      type="button"
      icon="pi pi-arrow-left"
      class="p-button-rounded p-button-secondary p-button-text"
      (click)="clickBack()"></button>
    <button
      pButton
      type="button"
      icon="pi pi-times"
      class="p-button-rounded p-button-secondary p-button-text"
      (click)="closeModal()"></button>
  </div>

  <ng-container [ngSwitch]="step">
    <ng-container *ngSwitchCase="NewsletterWelcomeSystemStepEnum.SELECT_TYPE">
      <div
        class="px-3"
        style="padding-top: 10rem; padding-bottom: 10rem">
        <p class="font-bold text-3xl mb-3">Добро пожаловать в ФРМ!</p>
        <p class="font-medium text-2xl">Мы рады, что вы решили воспользоваться бесплатным созданием</p>
        <p class="font-medium text-2xl">рассылки для своих должников! Надеемся, что ФРМ сможет</p>
        <p class="font-medium text-2xl">упростить создание писем по дебиторской задолженности.</p>

        <p class="font-medium text-2xl mt-6">Для начала создания выберите откуда будет производиться экспорт данных</p>

        <div class="flex justify-content-center mt-5 gap-8">
          <button
            pButton
            type="button"
            label="Excel"
            style="min-width: 185px !important; max-width: 185px !important"
            class="p-button-success p-button-xl"
            (click)="selectType(NewsletterWelcomeSystemStepEnum.EXCEL_TEMPLATE)"></button>

          <button
            pButton
            type="button"
            label="1С Предприятие"
            style="min-width: 185px !important; max-width: 185px !important"
            class="p-button-xl"
            (click)="selectType(NewsletterWelcomeSystemStepEnum.CONNECT_TO_1C)"></button>
        </div>
      </div>
    </ng-container>

    <crm-newsletter-welcome-system-connect-1c
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.CONNECT_TO_1C"
      [databases]="databases"
      (next)="nextStepFrom1C()"></crm-newsletter-welcome-system-connect-1c>
    <crm-newsletter-welcome-system-create-company
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.CREATE_COMPANY"
      [databases]="databases"
      (next)="addCompany($event)"></crm-newsletter-welcome-system-create-company>
    <crm-newsletter-welcome-system-excel
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.EXCEL_TEMPLATE"
      [newsletter]="newsletter"
      (next)="step = NewsletterWelcomeSystemStepEnum.NEWSLETTER_TEXT"></crm-newsletter-welcome-system-excel>
    <crm-newsletter-welcome-system-change-text
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.NEWSLETTER_TEXT"
      [newsletter]="newsletter"
      (next)="step = NewsletterWelcomeSystemStepEnum.NEWSLETTER_CHANNEL"></crm-newsletter-welcome-system-change-text>
    <crm-newsletter-welcome-system-select-channel
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.NEWSLETTER_CHANNEL"
      [newsletter]="newsletter"
      (next)="nextStepFromSelectChannel()"></crm-newsletter-welcome-system-select-channel>
    <crm-newsletter-welcome-system-create-contacts
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.CREATE_CONTACTS"
      [channel]="newsletter.channel"
      (next)="nextStepFromCreateContacts($event)"></crm-newsletter-welcome-system-create-contacts>
    <crm-newsletter-welcome-system-change-planning
      *ngSwitchCase="NewsletterWelcomeSystemStepEnum.NEWSLETTER_PLANNING"
      [newsletter]="newsletter"
      (closeModal)="closeModal(true)"></crm-newsletter-welcome-system-change-planning>
  </ng-container>
</div>
